<template>
  <common-template>
    <template v-slot:body>
      <div class="wrapper">
        <section id="my-page-section">
          <my-page-heading @updated="slideHeading" :heading="heading" />

          <p v-if="err.isErr" class="p-errmsg">
            <span>
              <img src="@/assets/attention.png" alt="エラー" width="22" height="22" />
            </span>
            {{ err.msg }}
          </p>

          <my-page-top v-if="heading === 'top' " />
          <loading v-if="heading === 'mod' && !ready" />
          <my-page-modify-profile @updated="slideHeading" v-if="heading === 'mod' && ready" :userData="userData" :preflist="preflist" :limitedPrefList="limitedPrefList" :incomes="incomes" :budgets="budgets"/>
          <my-page-modify-profile-complete @updated="slideHeading" v-if="heading === 'profile-complete'" />
          <my-page-change-password @updated="slideHeading" v-if="heading === 'pass' " :userData="userData" />
          <my-page-change-password-complete @updated="slideHeading" v-if="heading === 'password-complete'" />
        </section>

      </div>
    </template>
  </common-template>
</template>

<script>
import IsMobileMixin from '@/plugins/isMobile';
import MixinAPI from '@/plugins/mixin-api';
import Meta from '@/assets/json/meta.json';

import CommonFooter from '@/components/parts/CommonFooter';
import MyPageHeading from '@/components/mypage/MyPageHeading';

import MyPageTop from '@/components/mypage/MyPageTop';

import MyPageChangePassword from '@/components/mypage/MyPageChangePassword';
import MyPageChangePasswordComplete from '@/components/mypage/MyPageChangePasswordComplete';

import MyPageModifyProfile from '@/components/mypage/MyPageModifyProfile';
import MyPageModifyProfileComplete from '@/components/mypage/MyPageModifyProfileComplete';

import Loading from '@/components/common/Loading';
import { budgets, incomes } from '@/utils/incomesBudgetsData';

import CommonTemplate from '@/components/templates/CommonTemplate';

const ONE_MAN_EN = 10000;

export default {
  name: 'MyPageIndex',
  mixins: [IsMobileMixin, MixinAPI],
  components: {
    CommonFooter,
    MyPageHeading,
    MyPageChangePassword,
    MyPageTop,
    Loading,
    MyPageModifyProfile,
    MyPageModifyProfileComplete,
    MyPageChangePasswordComplete,
    CommonTemplate,
  },
  data() {
    return {
      heading: 'top',
      userData: {},
      err: {
        isErr: false,
        msg: '',
      },
      args: [],
      preflist: null,
      limitedPrefList: null,
      ready: false,
      budgets,
      incomes,
    };
  },
  beforeCreate() {
    if (this.$store.state.user === null) {
      location.href = '/';
    }
  },
  async mounted() {
    document.title = Meta.default.title;
    document.querySelector('meta[name="description"]').setAttribute('content', Meta.default.description);
    await this.getUserData();
    this.preflist = await this.getPrefectureList();
    this.limitedPrefList = await this.getPrefectureList(1);
    this.ready = true;
  },
  methods: {
    async getUserData() {
      this.err.isErr = false;
      this.err.msg = '';
      try {
        const userData = await this.$store.state.user;
        this.userData = {
          sei: userData.user_metadata.family_name,
          mei: userData.user_metadata.given_name,
          seikana: userData.user_metadata.phonetic_family_name,
          meikana: userData.user_metadata.phonetic_given_name,
          zip: userData.user_metadata.postal,
          address: userData.user_metadata.prefecture && userData.user_metadata.address ? userData.user_metadata.address : '',
          addressLocal: userData.user_metadata.building,
          email: userData.user_metadata.email,
          // remove prefix
          tel: userData.user_metadata.raw_phone_number ? `0${userData.user_metadata.raw_phone_number.slice(4, userData.user_metadata.raw_phone_number.length)}` : '',
          prefecture: userData.user_metadata.prefecture || '',
          desiredMonthlyPrice: userData.user_metadata.desired_monthly_price ? userData.user_metadata.desired_monthly_price / ONE_MAN_EN : '',
          motiveForSearch: userData.user_metadata.motive_for_search || [],
          motiveForSearchAdditional: userData.user_metadata.motive_for_search_additional || '',
          desiredPriceRangeUpper: userData.user_metadata.desired_price_range_upper || 0,
          desiredPriceRangeLower: userData.user_metadata.desired_price_range_lower || 0,
          desiredKind: userData.user_metadata.desired_kind || [],
          desiredAreaPref: userData.user_metadata.desired_area_pref || '',
          desiredAreaCity: userData.user_metadata.desired_area_city || '',
        };
      } catch (e) {
        this.err.isErr = true;
        this.err.msg = 'ユーザー情報取得にエラーが発生しました。';
      }
    },
    slideHeading(heading) {
      this.heading = heading;
      this.getUserData();
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang="scss">
@charset "UTF-8";
@media screen and (max-width: 1199px) {
  @import "../../assets/style/glocal_scss_sp.scss";
  @import "../../assets/style/parts_scss_sp.scss";
}
@media screen and (min-width: 1200px) {
  @import "../../assets/style/glocal_scss_pc.scss";
  @import "../../assets/style/parts_scss_pc.scss";
  body {
    margin: 0;
  }
}

.wrapper {
  input[type="text"],
  input[type="password"],
  input[type="tel"],
  input[type="email"] {
    border-width: 1px;
    border-style: solid;
    border-color: #ccc;
    padding: 4px;
  }

  input[type="email"],
  input[type="text"] {
    appearance: text;
    -webkit-appearance: text;
    -moz-appearance: text;
  }

  input[type="checkbox"] {
    appearance: checkbox;
    -webkit-appearance: checkbox;
    -moz-appearance: checkbox;
  }

  input[type="tel"] {
    appearance: tel;
    -webkit-appearance: tel;
    -moz-appearance: tel;
  }

  input[type="tel"] {
    appearance: tel;
    -webkit-appearance: tel;
    -moz-appearance: tel;
  }

  select {
    appearance: menulist;
    -webkit-appearance: menulist;
    -moz-appearance: menulist;
    border-width: 1px;
    border-style: solid;
    border-color: #ccc;
    padding: 3px;
  }
  }
  .wrapper {
    height: 100%;
    background-color: #fafafa;

    #my-page-section {
      width: 960px;
      margin: auto;
      padding-bottom: 100px;
    }
}

#my-page-section ::v-deep .my-page-header {
  margin-bottom: 30px;
  padding-left: 0;
  padding-right: 0;
  text-align: center;
  margin: 0;
  line-height: 1em;
  font-size: 20px;
  font-weight: bold;
}

#my-page-section .submit-button {
  margin-top: 30px;
  background-color: red;
  width: 100%;
  color: white;
  border-radius: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: bold;
  height: 55px;
}

input {
  padding-left: 8px !important;
  padding-right: 8px !important;
}

.p-errmsg {
  display: flex;
  justify-content: center;
}

@media (max-width: 999px) {
  .wrapper #my-page-section {
    padding-left: 12px;
    padding-right: 12px;
    width: 100%;
  }
}

@media (max-width: 639px) {
  #my-page-section {
    padding-bottom: 0px !important;
  }
  #my-page-section ::v-deep .my-page-header {
    text-align: left;
  }

  .wrapper #my-page-section {
    padding-left: 14px;
    padding-right: 14px;
  }
}

</style>
